import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const AndroidIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 68,
  height = 34,
  ...rest
}) => {
  return (
    <Icon
      data-testid="needs-based-filter-icon-android"
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <g fill="none" fillRule="evenodd">
        <path
          d="M42,11 C42,15.418 38.418,19 34,19 C29.582,19 26,15.418 26,11 C26,6.582 29.582,3 34,3 C38.418,3 42,6.582 42,11"
          fill="#ffffff"
          className={styles.white}
        />
        <path
          d="M34,2 C29.0297153,2 25,6.02971525 25,11 C25,15.9702847 29.0297153,20 34,20 C38.9702847,20 43,15.9702847 43,11 C43,6.02971525 38.9702847,2 34,2 Z M34,4 C37.8657153,4 41,7.13428475 41,11 C41,14.8657153 37.8657153,18 34,18 C30.1342847,18 27,14.8657153 27,11 C27,7.13428475 30.1342847,4 34,4 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <path
          d="M23 24 23 24C21.895 24 21 23.105 21 22L21 14C21 12.895 21.895 12 23 12L23 12C24.105 12 25 12.895 25 14L25 22C25 23.105 24.105 24 23 24M45 24 45 24C43.895 24 43 23.105 43 22L43 14C43 12.895 43.895 12 45 12L45 12C46.105 12 47 12.895 47 14L47 22C47 23.105 46.105 24 45 24"
          fill="#0050B3"
          className={styles.interactiveColor}
        />
        <polygon
          fill="#ffffff"
          className={styles.white}
          points="28.5 31.5 32.5 31.5 32.5 26.5 28.5 26.5"
        />
        <path
          d="M32.5,26 L28.5,26 C28.2238576,26 28,26.2238576 28,26.5 L28,31.5 C28,31.7761424 28.2238576,32 28.5,32 L32.5,32 C32.7761424,32 33,31.7761424 33,31.5 L33,26.5 C33,26.2238576 32.7761424,26 32.5,26 Z M32,27 L32,31 L29,31 L29,27 L32,27 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <polygon fill="#ffffff" className={styles.white} points="26 26 42 26 42 12 26 12" />
        <path
          d="M42,11 L26,11 C25.4477153,11 25,11.4477153 25,12 L25,26 C25,26.5522847 25.4477153,27 26,27 L42,27 C42.5522847,27 43,26.5522847 43,26 L43,12 C43,11.4477153 42.5522847,11 42,11 Z M41,13 L41,25 L27,25 L27,13 L41,13 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <polygon
          fill="#ffffff"
          className={styles.white}
          points="35.5 31.5 39.5 31.5 39.5 26.5 35.5 26.5"
        />
        <path
          d="M39.5,26 L35.5,26 C35.2238576,26 35,26.2238576 35,26.5 L35,31.5 C35,31.7761424 35.2238576,32 35.5,32 L39.5,32 C39.7761424,32 40,31.7761424 40,31.5 L40,26.5 C40,26.2238576 39.7761424,26 39.5,26 Z M39,27 L39,31 L36,31 L36,27 L39,27 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <path
          d="M32 8C32 8.552 31.552 9 31 9 30.448 9 30 8.552 30 8 30 7.448 30.448 7 31 7 31.552 7 32 7.448 32 8M38 8C38 8.552 37.552 9 37 9 36.448 9 36 8.552 36 8 36 7.448 36.448 7 37 7 37.552 7 38 7.448 38 8"
          fill="#00000"
          className={styles.defaultColor}
        />
        <path
          d="M26.5861466 2.58614661C26.759713 2.41258026 27.0291374 2.39329511 27.2240055 2.52829116L27.2932534 2.58614661 29.4142534 4.70714661C29.6095155 4.90240876 29.6095155 5.21899124 29.4142534 5.41425339 29.240687 5.58781974 28.9712626 5.60710489 28.7763945 5.47210884L28.7071466 5.41425339 26.5861466 3.29325339C26.3908845 3.09799124 26.3908845 2.78140876 26.5861466 2.58614661ZM40.7067466 2.58614661C40.9020088 2.39088446 41.2185912 2.39088446 41.4138534 2.58614661 41.5874197 2.75971296 41.6067049 3.02913736 41.4717088 3.2240055L41.4138534 3.29325339 39.2928534 5.41425339C39.0975912 5.60951554 38.7810088 5.60951554 38.5857466 5.41425339 38.4121803 5.24068704 38.3928951 4.97126264 38.5278912 4.7763945L38.5857466 4.70714661 40.7067466 2.58614661Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
      </g>
    </Icon>
  )
}
